import {
  REPORTS,
  REPORTS_SUCCESS,
  REPORTS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  reports: [],
};

const reportsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REPORTS:
      return { ...state, loading: true };
    case REPORTS_SUCCESS:
      return {
        ...state,
        reports: action?.payload,
        loading: false,
      };
    case REPORTS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default reportsReducer;
